import axios from "axios";
import config from '../config';

const PayPalService = {
    
  create(orderId) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${config('API_URL')}paypal/create`,{
            orderId
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default PayPalService;



// WEBPACK FOOTER //
// ./services/PayPalService.js